<template>
  <!-- <div class="content ">
    <div class="contact">
      <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p>
      <div class="desc" :style="{ color: textColor }">
        <p v-for="(item, index) in desc" :key="index">
          <span>{{ item.text }}</span>
        </p>
      </div>
    </div>
  </div> -->
  <div class="main contact">
    <div class="mseciton">
      <Header></Header>
      <div class="page1">
        <div class="wrap">
          <h1>
            We Are Here To Help You
            <svg t="1739624642579" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3216"><path d="M512.268258 1022.835842c-68.658678 0-135.399619-13.564433-198.369591-40.316509-60.752236-25.809077-115.373446-62.712976-162.346233-109.685763-46.971763-46.971763-83.875662-101.592974-109.685763-162.346233C15.115619 647.517366 1.551186 580.777449 1.551186 512.118771S15.115619 376.719151 41.866671 313.74918c25.810101-60.752236 62.714-115.373446 109.685763-162.346233 46.972787-46.971763 101.593997-83.875662 162.346233-109.685763 62.969971-26.751052 129.710912-40.315485 198.369591-40.315485s135.398595 13.564433 198.368567 40.315485c60.752236 25.810101 115.373446 62.714 162.346233 109.685763 46.971763 46.972787 83.875662 101.593997 109.685763 162.346233 26.752076 62.969971 40.316509 129.710912 40.316509 198.369591s-13.564433 135.398595-40.316509 198.368567c-25.809077 60.75326-62.712976 115.37447-109.685763 162.346233-46.971763 46.972787-101.592974 83.876686-162.346233 109.685763C647.666853 1009.27141 580.925912 1022.835842 512.268258 1022.835842zM512.268258 50.548195c-62.018782 0-122.293887 12.247716-179.152287 36.403219-54.923257 23.333323-104.317532 56.709936-146.810821 99.204249s-75.870926 91.888588-99.204249 146.810821c-24.155503 56.8584-36.403219 117.133505-36.403219 179.152287 0 62.017758 12.247716 122.292863 36.403219 179.152287 23.333323 54.923257 56.709936 104.317532 99.204249 146.811845 42.493289 42.493289 91.888588 75.870926 146.810821 99.204249 56.8584 24.155503 117.133505 36.403219 179.152287 36.403219 62.017758 0 122.292863-12.247716 179.152287-36.403219 54.923257-23.333323 104.317532-56.71096 146.811845-99.204249 42.493289-42.494313 75.870926-91.888588 99.204249-146.811845 24.155503-56.8584 36.403219-117.133505 36.403219-179.152287s-12.247716-122.293887-36.403219-179.152287c-23.334347-54.923257-56.71096-104.317532-99.205273-146.810821-42.493289-42.493289-91.887565-75.870926-146.810821-99.204249C634.561121 62.795911 574.286016 50.548195 512.268258 50.548195z" fill="#444444" p-id="3217"></path><path d="M509.635849 662.039132c-12.806758 0.001024-23.601581-9.925544-24.490313-22.894076-3.937863-57.461468 9.411554-96.388564 21.305006-118.92428 10.555234-20.004671 31.440447-38.653719 41.477595-47.615787 1.05153-0.938903 1.925928-1.717056 2.568928-2.310909 52.08607-48.130801 51.437951-78.389684 51.308941-80.62073-0.051194-0.301022-0.097269-0.603068-0.136177-0.906139-3.954245-30.151375-17.538132-50.213384-41.527765-61.330731-13.282864-6.155599-29.039436-9.304046-46.834563-9.356264-0.558018-0.002048-1.022861-0.004096-1.388389-0.008191-1.139584-0.015358-2.262787-0.022525-3.434111-0.025597-37.411746 0.05017-62.803078 15.916297-77.620746 48.503496-11.747036 25.834675-12.07468 52.3574-12.07468 52.618491 0 13.5716-11.001648 24.573248-24.573248 24.573248s-24.573248-11.001648-24.573248-24.573248c0-1.498968 0.186347-37.121986 16.48353-72.962068 10.05353-22.10978 24.098165-39.887501 41.744829-52.838626 22.062681-16.19377 49.164926-24.425808 80.553154-24.467788 1.393508-0.008191 2.76449 0.011263 4.143664 0.029693l0.884637 0.004096c24.935703 0.072696 47.596333 4.7539 67.35732 13.912554 27.367431 12.683891 61.589774 40.134257 69.508503 98.920633 0.913306 5.3969 2.022174 19.359624-5.166525 39.883405-9.654215 27.562993-30.277313 56.07308-61.300014 84.739821-0.798631 0.737197-1.881901 1.706817-3.188379 2.87507-6.652183 5.939559-24.320348 21.715584-30.745229 33.892652-8.918041 16.901275-18.887613 46.689171-15.739165 92.629881 0.926616 13.53986-9.296879 25.268466-22.836738 26.195082C510.770314 662.019678 510.20001 662.039132 509.635849 662.039132zM602.014878 390.757643c0.002048 0.010239 0.004096 0.020478 0.006143 0.029693C602.018974 390.777097 602.016926 390.767882 602.014878 390.757643zM602.008735 390.731022c0.002048 0.007167 0.003072 0.014334 0.005119 0.021502C602.011807 390.74638 602.010783 390.738189 602.008735 390.731022zM601.795767 389.541267 601.795767 389.541267C601.795767 389.541267 601.795767 389.541267 601.795767 389.541267z" fill="#444444" p-id="3218"></path><path d="M513.811253 706.462444c16.419025 0 29.729534 13.296175 29.729534 29.714176l0 7.870606c0 16.410834-13.195834 29.714176-29.729534 29.714176l0 0c-16.419025 0-29.729534-13.296175-29.729534-29.714176l0-7.870606C484.081719 719.765786 497.277553 706.462444 513.811253 706.462444L513.811253 706.462444z" fill="#444444" p-id="3219"></path></svg>
          </h1>
          <div class="desc">Feel free to reach out to us via email at <svg t="1739624904938" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4670"><path d="M926.47619 355.644952V780.190476a73.142857 73.142857 0 0 1-73.142857 73.142857H170.666667a73.142857 73.142857 0 0 1-73.142857-73.142857V355.644952l304.103619 257.828572a170.666667 170.666667 0 0 0 220.745142 0L926.47619 355.644952zM853.333333 170.666667a74.044952 74.044952 0 0 1 26.087619 4.778666 72.704 72.704 0 0 1 30.622477 22.186667 73.508571 73.508571 0 0 1 10.678857 17.67619c3.169524 7.509333 5.12 15.652571 5.607619 24.210286L926.47619 243.809524v24.380952L559.469714 581.241905a73.142857 73.142857 0 0 1-91.306666 2.901333l-3.632762-2.925714L97.52381 268.190476v-24.380952a72.899048 72.899048 0 0 1 40.155428-65.292191A72.97219 72.97219 0 0 1 170.666667 170.666667h682.666666z" p-id="4671" fill="#d4237a"></path></svg> alleshen777@gmail.com for any inquiries or assistance you may need. We're here to help!</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {Header, Footer},
  data() {
    return {
      title: "",
      desc: [],
      email: "",
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[2];
      this.email = config.email;
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.main.contact{
  .mseciton{
    background-image: none;
    height: auto;
    min-height: auto;
    background-color: #000;
    padding: 0;
    background-color: transparent;
    ::v-deep{
      header{
        padding-top: 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
  .page1{
    min-height: calc(100vh - 122px);
    color: #444;
    .wrap{
      max-width: 800px;
      text-align: center;
      h1{
        margin-top: 0;
        text-transform: capitalize;
        svg{
          width: 24px;
        }
      }
      .desc{
        line-height: 30px;
        svg{
          width: 20px;
          position: relative;
          top: 4px;
        }
      }
    }
  }
}

.content {
  padding: 10px 0;
  flex: 1;
  background-image: url("~@/assets/images/contact.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .contact {
    transform: translateX(-100%);
    .desc {
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 12px;
      }
    }
  }
}
</style>
